import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEventList";

const useEventListParameters = (options?: Toolkit.GoogleAnalytics.Options): TrackEventListParameters => ({
    ...ga.use.eventParameters(options),
    currency: ga.use.currency(options),
    items: ga.use.items(options),
});

export default useEventListParameters;
